// ----------------------------------------------------------------------------
// Component: Collection List
// ----------------------------------------------------------------------------
//
// A list of collections
//
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------
import $ from 'jquery';
import Swiper, { Navigation, Scrollbar, A11y, Keyboard } from 'swiper';
import 'snippets/card/card';
import 'snippets/icon/icon';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import './_collection-list.scss';



// -------------------------------------
// Variables
// -------------------------------------

// -------------------------------------
// Hooks
// -------------------------------------
function handleSlides(swiperEl) {
    swiperEl.slides.forEach(function(slide, index) {
        let slideLink = slide.querySelector('a');
        slideLink.addEventListener('focus', function(e) {
            swiperEl.slideTo(index);
        })
    });
}

$(function() {
    $(".carousel--collection-list").each(function(index, element){
        var $this = $(this);

        // Generate unique class for each collection list slider
        $this.addClass("collection-list-instance-" + index);

        // Generate unique btn classes for slider arrows
        $this.parents('.collection-list').find(".swiper-button-prev").addClass("collection-list-btn-prev-" + index);
        $this.parents('.collection-list').find(".swiper-button-next").addClass("collection-list-btn-next-" + index);
        
        // Generate unique btn classes for slider arrows
        $this.parents('.collection-list').find(".swiper-scrollbar").addClass("collection-list-swiper-scrollbar-" + index);

        var swiper = new Swiper(".collection-list-instance-" + index, {
            // Optional parameters
            modules: [Navigation, Scrollbar, A11y, Keyboard],
            slidesPerView: 2.7,
            spaceBetween: 15,
            observer: true,
            observeParents: true,
            a11y: false,
            watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.

            breakpoints: {
                // when window width is >= 680px
                680: {
                    slidesPerView: 10
                }
            },

            // // Navigation arrows
            navigation: {
              nextEl: ".collection-list-btn-next-" + index,
              prevEl: ".collection-list-btn-prev-" + index
            },

            // Scrollbar
            scrollbar: {
                el: ".collection-list-swiper-scrollbar-" + index,
                draggable: true,
            }
        });

        swiper.slides.forEach(function(slide, index) {
            let slideLink = slide.querySelector('a');
            slideLink.addEventListener('focus', function(e) {
                swiper.slideTo(index);
            })
        });
    });
});
